import {Type} from "@angular/core";
import {MvsFormFieldDto} from "../../../../../dto/form/dto/mvs-form-field.dto";

export class UiWidgetFormFields {

  public formPath: string = '';
  public attributePath: string = '';
  public field: string = '';
  public uiPriority: number = 0;
  public uiStyle: string = '';
  public uiShowLabel: boolean = true;
  public uiCssStyle: string = '';
  public uiHidden: boolean = false;
  public uiHideNull: boolean = false;
  public uiOutputField: string = '';
  public uiInputField: string = '';
  public uiLabel: string = '';
  public uiEditable: boolean = false;
  public uiLabelIcon: boolean = false;
  public uiLabelIconValue: string = '';
  public isUiFieldEdit: boolean = false;
  public lgColspan: number = null;
  public mdColspan: number = null;
  public smColspan: number = null;
  public uiBoolIconYes: string = '';
  public uiBoolIconNo: string = '';
  public uiBoolIconNull: string = '';
  public iconSize: string = '';
  public uiFieldReference: string = '';
  public uiFieldLabel: string = '';
  public uiSearchField?: string = '';
  public tooltip: string = '';
  public absoluteId: string = '';
  public uiOutputControl?: string = '';
  public skip: boolean = false;
  public formField: MvsFormFieldDto = new MvsFormFieldDto();
  public disabled: boolean = false;
  public defaultValue: any = null;
  public mostUsed: boolean = false;
  public mostUsedFrequency: number = 3;
  public sourcePath?: string = '';
  // 04.06.2025 Added confirmation fields
  uiConfirmable: string;
  public uiConfirmableGroupField: string;

  public uiGenericTypeName?: string = '';

  // New Property
  public uiOutputConfig?: {
    component: Type<any>;
    data?: any; // You can include additional metadata if needed
  } = null;

  public uiInputConfig?: {
    component: Type<any>;
    data?: any; // You can include additional metadata if needed
  } = null;

  public uiConfigData?: any;
}
